module.exports = __webpack_public_path__ + "static/media/19.634baed2.jpg";